import { render, staticRenderFns } from "./AuthSetMfa.vue?vue&type=template&id=2d235f84&scoped=true"
import script from "./AuthSetMfa.ts?vue&type=script&lang=ts&external"
export * from "./AuthSetMfa.ts?vue&type=script&lang=ts&external"
import style0 from "./AuthSetMfa.scss?vue&type=style&index=0&id=2d235f84&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d235f84",
  null
  
)

export default component.exports